export const SHOW_MODAL = 'modals/addAttachment/SHOW_MODAL';
export const HIDE_MODAL = 'modals/addAttachment/HIDE_MODAL';
export const ATTACHMENT_CREATE_STARTED = 'modals/addAttachment/ATTACHMENT_CREATE_STARTED';
export const ATTACHMENT_CREATED = 'modals/addAttachment/ATTACHMENT_CREATED';
